<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-9 col-xs-9 tabletWidth">
            <div class="col-sm-12 col-xs-12 titleDiv">
              <h3 class="subTitle">{{ $t('itemslist_title') }}</h3>
              <h5>{{ $t('itemslist_desc') }}</h5>
            </div>
            <div class="card content-wrap-card col-sm-12 col-xs-12">
              <div class="col-sm-12 col-xs-12 divWrap flex-wrap">
                <div class="col-sm-12 mb100">
                  <div class="col-12 inputDiv">
                    <label >{{ $t('itemslist_choose_dept') }}<span class="required-span"/></label>
                      <a-radio-group 
                        v-model:value="medicalDept"
                        class="d-flex flex-wrap radio-div"  
                      >
                        <a-radio v-for="(item, i) in deptList" :key="i" :value="item.code">{{ item.name }}</a-radio>
                      </a-radio-group>
                  </div>
                  <div class="col-12 inputDiv">
                    <label >{{ $t('itemslist_table_type') }}</label>
                    <a-input
                      class="input-text-common"
                      :placeholder="$t('itemslist_addpage_placeholder_producttype')" 
                      v-model:value="productType"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap" v-if="medicalDept==='DENT'">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_table_brand') }}<span class="required-span"/></label>
                  <a-select
                    style="width:calc(100% - 150px);"
                    v-model:value="itemBrand"
                    :placeholder="$t('itemslist_addpage_placeholder_brand')"
                    :default-active-first-option="false" 
                    :options="itemBrandOptions"
                    @input="handleInputItemBrand"
                    :searchValue="itemBrand"
                    show-search
                  >
                    <template #notFoundContent>
                      {{ $t('noresult_search') }}
                    </template>
                  </a-select>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_table_itemcode') }}<span class="required-span"/></label>
                  <a-input 
                    class="input-text-common" 
                    :placeholder="$t('itemslist_addpage_placeholder_itemcode')" 
                    v-model:value="itemCode" 
                    @input="handleItemCode"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_table_itemname') }}<span class="required-span"/></label>
                  <a-input 
                    class="input-text-common" 
                    :placeholder="$t('itemslist_addpage_placeholder_itemname')" 
                    v-model:value="itemName" 
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_table_itemspec') }}</label>
                  <a-input 
                    class="input-text-common" 
                    :placeholder="$t('itemslist_table_itemspec_placeholder')" 
                    v-model:value="itemSpec" 
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_table_itemdesc') }}</label>
                  <a-textarea 
                    class="input-textarea-common"
                    :placeholder="$t('itemslist_addpage_placeholder_itemdesc')" 
                    v-model:value="description" 
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_addpage_placeholder_properties') }}</label>
                  <div class="property-area d-flex">
                    <div 
                      v-for="(item, i) in jsonContents" 
                      :key="i" 
                      class="w-100" 
                      style="margin-bottom: 10px; display: flex; align-items: center;"
                    >
                      <a-input 
                        class="key-input input-text-common"
                        v-model:value="item.propertyName" 
                        :placeholder="$t('itemslist_addpage_placeholder_key')"  
                        required/>
                      <a-input 
                        class="value-input input-text-common"
                        :class="jsonContents.length > 0 ? '' : 'value-full-width'"
                        type="text" 
                        v-model:value="item.propertyValue"
                        :placeholder="$t('itemslist_addpage_placeholder_value')"
                      required/>
                      <a-button v-if="jsonContents.length > 0" 
                        @click="removeItem(i)" 
                        shape="circle"  
                      >
                        <template #icon>
                          <i class="fa-duotone fa-minus"/>
                        </template>
                      </a-button>
                    </div>
                    <a-button  
                      class="add-prop-btn" 
                      @click="addRow"
                    >
                      <template #icon>
                        <i class="fa-solid fa-plus"/> 
                      </template>
                      {{ $t('itemslist_addpage_add_value') }}
                    </a-button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_table_unregister') }}</label>
                  <div class="d-flex align-items-center">
                    <a-switch v-model:checked="unregisterYn" />
                    <p class="true-color" id="unregister-text">
                      {{ unregisterYn
                        ? $t('itemslist_addpage_no_register_desc_y')
                        : $t('itemslist_addpage_no_register_desc_n')
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_allow_dup') }}</label>
                  <div class="d-flex align-items-center">
                    <a-switch v-model:checked="duplicateYn" />
                    <p class="true-color" id="duplicate-text">
                      {{ duplicateYn
                      ? $t('itemslist_addpage_no_duplicate_desc_y')
                      : $t('itemslist_addpage_no_duplicate_desc_n')
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_addpage_certificate_image') }}<span class="required-span"/></label>
                  <div class="file-input-wrap">
                    <input
                      type="file"
                      accept="image/jpeg, image/png, image/gif"
                      @change="changeLogoImage"
                      id="fileInput"
                      ref="fileInput"
                    />
                    <div class="file-relative-wrap">
                      <a-input 
                      class="input-text-common file-name-input" 
                      :placeholder="$t('itemslist_addpage_certificate_image_placedholer')"
                      readonly
                      v-model:value="fileName"
                      />
                      <div  v-if="fileName || fileData" class="download-wrap" @click="downloadLogoImage()">
                        <i class="fa-solid fa-down-to-bracket"/>
                      </div>
                      <a-button 
                        class="black no-radius-left no-radius-right img-add-btn"
                        @click="clickFileInput"
                      >
                      {{ $t('itemslist_addpage_certificate_image_add_modify') }}
                      </a-button>
                    </div>
                    <a-button @click="deleteImage">
                      {{ $t('itemslist_addpage_certificate_image_delete') }}
                    </a-button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv"  style="margin-bottom: 0px !important;">
                  <label />
                  <div class="img-desc">
                    <ul style="padding-left: 1rem;">
                      <li>
                        {{ $t('itemslist_addpage_certificate_image_instruction_size') }}
                      </li>
                      <li>
                        {{ $t('itemslist_addpage_certificate_image_instruction_ext') }}
                      </li>
                      <li>
                        {{ $t('itemslist_addpage_certificate_image_instruction_file_size') }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label >{{ $t('itemslist_addpage_certificate_bg_color') }}<span class="required-span"/></label>
                  <div class="d-flex align-items-center colorPicker">
                    <color-picker v-model:pureColor="pureColor" />
                    <a-input class="d-none" id="rgbaInput" v-model:value="pureColor" @input="convertToHex"/>
                    <p class="true-color2">{{ hexValue }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex item-btn-area">
              <a-button
              class="certi-cancel-btn"
                @click="$router.push('/item')"
                >
                <p>{{ $t('common_cancel') }}</p>
              </a-button>
              <a-button
                type="primary"
                @click="uploadImgAndData"
                class="certi-submit-btn"
                >
                <p>{{ $t('itemslist_addpage_add_item') }}</p>
              </a-button>
            </div>

          </div>
          <div class="col-3 phone-preview-wrap" ref="phone-preview-wrap">
            <div class="island" >
              <img src="@/assets/img/phoneEye.png"  />
            </div>
            <div class="col-sm-12 phoneBg" :style="hexValue.length > 0
                ? 'background-color:' +
                hexValue
                : 'background-color:#F1F2F3'
              ">
              <div class="imgDiv">
                <img ref="prevImg" id="prevImg" :src="hasImage
                    ? certificateImgUrl
                    : 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/Brand%253DCertiLife1024.png'
                  " 
                   />
              </div>
              <div class="col-sm-12 phoneText">
                <em />
                <div class="certTitle" :class="{ open: isOpen }">
                  <h4>
                    {{ itemName.length > 0 ? itemName : 'CERTILIFE' }}
                  </h4>
                  <p>{{ description }}</p>
                  <p>
                    {{ $t('itemslist_addpage_additional_desc') }}
                  </p>
                </div>
                <button class="overflowBtn" type="button" :class="{ clicked: isClicked }">
                  <img src="@/assets/img/rightGray.png"  />
                </button>
                <div class="cert_info">
                  <h4>{{ $t('itemslist_addpage_detail') }}</h4>
                  <table>
                    <tr>
                      <td class="head">{{ $t('itemslist_addpage_brand') }}</td>
                      <td>{{ brand }}</td>
                    </tr>
                    <tr v-if="jsonContents.length > 0 && 
                      (jsonContents[0].propertyName || 
                      jsonContents[0].propertyValue)" 
                      v-for="(item, i) in jsonContents">
                      <td class="head">{{ item.propertyName }}</td>
                      <td>{{ item.propertyValue }}</td>
                    </tr>
                    <tr>
                      <td class="head">{{ $t('itemslist_addpage_surgery_date') }}</td>
                      <td>{{ date }}</td>
                    </tr>
                    <tr v-if="convertMedicalDept(medicalDept)">
                      <td class="head">{{ $t('itemslist_addpage_dept') }}</td>
                      <td>{{ convertMedicalDept(medicalDept) }}</td>
                    </tr>
                  </table>
                </div>
                <div class="cert_info">
                  <h4>{{ $t('itemslist_addpage_history') }}</h4>
                  <table>
                    <tr>
                      <td class="head">{{ $t('itemslist_addpage_issued_at') }}</td>
                      <td>{{ date }}</td>
                    </tr>
                    <tr>
                      <td class="head">{{ $t('itemslist_addpage_sent_from') }}</td>
                      <td>{{ $t('itemslist_addpage_issued_self') }}</td>
                    </tr>
                    <tr>
                      <td class="head">{{ $t('itemslist_addpage_transaction_hash') }}</td>
                      <td>
                        <button type="button" class="hash-btn">
                          <input type="text" value="0x4f2a7d8e...b5123d4887" readonly disabled />
                          <i class="fa-regular fa-copy" />
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfile } from '@/utils/tokenStore';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import {
  changeBytesToMegabytes,
  oneBtnDialog,
  boolToYn,
} from '@/utils/utils';
import { MedicalDeptText } from '@/utils/enums';
import dayjs from 'dayjs';
import 'dayjs/locale/ko'
import { MedicalDept } from '@/utils/enums';
export default {
  name: 'AddItem',
  components: { ColorPicker },
  computed: {
    date() {
      return dayjs().format('YYYY/MM/DD');
    },
  },
  data() {
    return {
      brand: '',
      medicalDept: '', // 과
      companyInfo: JSON.parse(getProfile('CompanyInfo')),
      productType: '', // 제품분류
      unregisterYn: false, // 무등록 발행
      itemBrand: '', // 브랜드 명
      itemCode: '', // 품목 코드
      itemName: '', // 품목명
      itemSpec: '', // 품목 스펙
      description: '', // 품목명
      duplicateYn: false, // 중복 허용
      fileName: '', // 이미지 파일명
      fileData: null, // 실제 파일 정보가 담긴 폼데이터
      certificateImgUrl: '', // objectStorage 상 이미지 url
      hasImage: false,

      background_color: null, // NFT배경색
      deptList: [], // 과 목록
      jsonContents: [
        {
          propertyName: '',
          propertyValue: '',
        },
      ],
      pureColor: 'rgb(255, 255, 255)',
      hexValue:'',
      hasRequested: false,
      isOpen: false,
      isClicked: false,
      itemBrandOptions:[],
    };
  },
  beforeUnmount() {
  },
  // rgba코드 hex코드로 바꾸기
  watch: {
    pureColor(newValue) {
      this.convertToHex();
    },
  },
  // rgba코드 hex코드로 바꾸기
  async mounted() {
    this.brand = getProfile('companyManu') ? getProfile('companyManu') : '제조사';
    this.convertToHex(); // 초기 Hex 값 
    await this.getDeptList();
    this.itemBrandOptions = await this.getDentItemStepOne()
    this.itemBrandOptions = this.itemBrandOptions.map(i=>{
      return {
        label:i.brand,
        value:i.brand,
      }
    });
  },
  methods: {
    handleInputItemBrand(event){
      this.itemBrand = event.target.value; 
    },
    convertMedicalDept(value) {
      return MedicalDeptText[value] || '';
    },
    

    /* 
      
    클릭클릭 제조사 정보 가져오기(치아 선택 시에 바인딩)

      고민: 거의 고정값이므로 페이지 로드 시에 1회만 호출? 치아 선택 마다 호출?

    */
    async getDentItemStepOne() {
      const obj = {};
      obj.manufacturer = this.companyInfo.name;

      let resultCompanies = [];
      try {
        const response = await this.$apiInstance.post(`/items/dent/2`, obj);
        if (response.status === 200 || response.status === 201) {
          if(response.data) resultCompanies = response.data;
        }
      } catch(error) {
        console.log(error);
        await oneBtnDialog('품목 가져오기 실패', '품목 가져오기에 실패했습니다.', false);
      } finally {
        return resultCompanies;
      }
    },

    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospitalw_message_get_dept_title'),this.$i18n.t('hospitalw_message_get_dept_content'), false);
      }
    },
    handleItemCode(event) {
      let inputValue = event.target.value;
      const regex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]*$/;
      if (!regex.test(inputValue)) {
          event.target.value = inputValue.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]/g, '');
      }
    },
    async validateData() {
      let result = true;
      const hexRegex = /^#([0-9a-fA-F]{3}){1,2}$/;

      if(!this.medicalDept) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_nodept_err_title'), this.$i18n.t('itemslist_nodept_err_content'), false);
        return result;
      } else if (this.medicalDept === MedicalDept.DENT && !this.itemBrand) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_nobrand_err_title'), this.$i18n.t('itemslist_nobrand_err_content'), false);
        return result;
      } else if (!this.itemCode) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_nocode_err_title'), this.$i18n.t('itemslist_nocode_err_content'), false);
        return result;
      } else if (!this.itemName) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_noname_err_title'), this.$i18n.t('itemslist_noname_err_content'), false);
        return result;
      } else if (!this.fileName || !this.fileData) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_noimage_err_title'), this.$i18n.t('itemslist_noimage_err_content'), false);
        return result;
      } else if (this.background_color && !hexRegex.test(this.background_color)) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_color_err_title'), this.$i18n.t('itemslist_color_err_content'), false);
        return result;
      } 
      return result;
    },
    // 이미지와 데이터 업로드 및 후처리
    async uploadImgAndData() {
      if (await this.validateData()) {
        if(!this.hasRequested) {
          this.hasRequested = true;
          await this.uploadImage();
          if (this.certificateImgUrl !== '') {
            await this.registerItem();
            await oneBtnDialog(this.$i18n.t('itemslist_add_done_title'), this.$i18n.t('itemslist_add_done_content'), false);
            this.$router.push('/item');
          }
        }
      }
    },
    
    // 이미지 오브젝트스토리지에 업로드
    async uploadImage() {
      if (this.fileData) {
        try {
          const response = await this.$apiInstance.post(`/object-storages`, this.fileData);
          if (response.status === 200 || response.status === 201) {
            this.certificateImgUrl = response.data.url;
          }
        } catch (error) {
          console.log(error);
          await oneBtnDialog(this.$i18n.t('itemslist_add_fail_title'), this.$i18n.t('itemslist_add_fail_content'), false);
          this.hasRequested = false;
        }
      } else {
      }
    },

    // 데이터 서버에 전송
    async registerItem() {
      
      const obj = {};
      obj.medicalDept = this.medicalDept;
      obj.productType = this.productType;
      obj.itemName = this.itemName;
      obj.brand = this.itemBrand;
      obj.itemCode = this.itemCode;
      obj.unregisterYn = boolToYn(this.unregisterYn);
      obj.duplicateYn = boolToYn(this.duplicateYn);
      obj.certificateImgUrl = this.certificateImgUrl;
      if(this.description) obj.description = this.description;
      if(this.background_color && this.background_color !== '') obj.background_color = this.background_color;

      const newJsonContents = new Array();
      this.jsonContents.forEach((element) => {
        if (element.propertyName && element.propertyValue) {
          const newObject = {};
          newObject[element.propertyName] = element.propertyValue;
          if(!obj.itemSpec){
            obj.itemSpec =element.propertyValue
          }
          newJsonContents.push(newObject);
        }
      });

      if(this.itemSpec) obj.itemSpec = this.itemSpec;
      if (newJsonContents.length > 0) {
        obj.jsonContents = JSON.stringify(newJsonContents);
      } else {
        obj.jsonContents = '';
      }
      try {
        const response = await this.$apiInstance.post(`/items`, obj);
        if (response.status === 200 || response.status === 201) {

        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('itemslist_add_fail_title'), this.$i18n.t('itemslist_add_fail_content'), false);
        this.hasRequested = false;
      }
    },
    // 속성 줄 추가
    addRow() {
      const propertyObj = {
        propertyName: '',
        propertyValue: '',
      }
      this.jsonContents.push(propertyObj);
    },
    removeItem(index) {
      this.jsonContents.splice(index, 1);
    },
    deleteImage() {
      this.fileData = null;
      this.fileName = '';
      this.certificateImgUrl = '';
      this.hasImage = false;
      this.$refs.prevImg.src = 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/Brand%253DCertiLife1024.png';
    },
    async clickFileInput() {
      let fileInput = document.getElementById('fileInput');
      fileInput.click();
    },
     // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/gif' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert(this.$i18n.t('hospitalw_message_file_type'));
        result = false;
      } else if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t('hospitalw_message_file_size'));
        result = false;
      }

      return result;
    },
    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      const fileInput = this.$refs.fileInput;
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            this.hasImage = true;
            document.getElementById('prevImg').src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.fileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          this.fileData = formData;
        }
      }
    },
    downloadLogoImage() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.certificateImgUrl;
        downloadLink.download = this.fileName;
        downloadLink.click();
      }
    },

    // rgba코드 hex코드로 바꾸기
    convertToHex() {
      const rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/;
      const matches = this.pureColor.match(rgbaRegex);
      if (matches) {
        const r = parseInt(matches[1]);
        const g = parseInt(matches[2]);
        const b = parseInt(matches[3]);
        const a = matches[4] ? parseFloat(matches[4]) : 1;

        const toHex = (dec) => {
          const hex = dec.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        };
        const hexR = toHex(r);
        const hexG = toHex(g);
        const hexB = toHex(b);
        const hexA = toHex(Math.round(a * 255));
        this.hexValue = `#${hexR}${hexG}${hexB}${hexA}`.substring(0, 7); // 7자리까지만 추출
        this.background_color = this.hexValue;
      } else {
        this.hexValue = ''; // 유효하지 않은 값인 경우에는 빈 문자열로 설정
        this.background_color = '';
      }
    },
    toggleOverflow() {
      this.isOpen = !this.isOpen;
      this.isClicked = !this.isClicked;
    },
  },
};
</script>

<style lang="scss" scoped>

@media screen and (max-width:767px) {
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }

  .file-input-wrap,
  .file-input-wrap .file-relative-wrap,
  .content-wrap-card .inputDiv{
    display: flex;
    flex-direction: column;
  }

  .item-btn-area,
  .content-wrap-card .inputDiv,
  .colorPicker,
  .file-input-wrap,
  .property-area,
  .content-wrap-card .inputDiv .input-textarea-common,
  .content-wrap-card .inputDiv .input-text-common{
    width: 100% !important;
    max-width: none;
  }

  /* 머리말 줄.

     .card-header 가 d-flex 이고 그 안에 `col-sm-9`(본문)과 `col-3 phone-preview-wrap`(폰 미리보기)이
     나란히 놓인다. 미리보기는 폰에서 display:none 이라 사라지지만, 남은 col-sm-9 는
     576px 미만에서 부트스트랩이 폭을 정해 주지 않는다(.col-sm-* 는 576px 이상에서만 정의된다).
     .row 안도 아니라 `.row > *` 의 width:100% 도 걸리지 않아, 내용 크기만큼 벌어지며 43px 넘쳤다.

     폭을 명시하고 줄바꿈을 허용해 컨테이너 안에 가둔다. */
  .card-header.d-flex {
    flex-wrap: wrap;
  }

  .card-header > .col-sm-9 {
    width: 100%;
    min-width: 0;
  }
}
</style>